module.exports = __webpack_public_path__ + "static/img/证书.7418bf9d.jpg";